import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import TermsAndConditions from '../Components/LegalComponents/TermsAndConditions'

function Terms() {
  return (
    <div>
        <Navbar/>
        <TermsAndConditions/>
        <Footer/>
    </div>
  )
}

export default Terms